import { ChartOption, ChartType, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const xAxisData: Array<string> = [];
  for (let i = 0; i < datas.rowCount; i++) {
    if (datas.rowDimNodes[i][0].total) {
      continue;
    }
    xAxisData.push(datas.rowDimNodes[i][0].label);
  }
  const xAxis: any = {
    type: "category",
    data: xAxisData,
  };

  if (!definition.rowDims[0].dateUnit) {
    xAxis.axisLabel = {
      rotate: 30,
    };
  }

  const yAxis: any = {
    type: "value",
  };

  if (!chartOption.hideAxisTitle) {
    if (!isEmpty(chartOption.xaxisTitle)) {
      xAxis.name = chartOption.xaxisTitle;
    }
    if (!isEmpty(chartOption.yaxisTitle)) {
      yAxis.name = chartOption.yaxisTitle;
    }
  }

  const series = [];

  const seriesData: Array<number> = [];
  for (let j = 0; j < datas.rowCount; j++) {
    if (datas.rowDimNodes[j][0].total) {
      continue;
    }

    if (datas.dataValues[datas.rowColIndexes[j][0]]) {
      seriesData.push(datas.dataValues[datas.rowColIndexes[j][0]][0]);
    } else {
      seriesData.push(0);
    }
  }

  let seriesLabel: any = {};
  if (!chartOption.hideLabel) {
    seriesLabel = {
      normal: {
        show: true,
        position: "top",
      },
    };
  }

  series.push({
    type: chartOption.chartType == ChartType.BAR ? "bar" : "line",
    label: seriesLabel,
    data: seriesData,
  });

  const option: any = {
    tooltip: {
      trigger: "axis",
    },
    xAxis: xAxis,
    yAxis: yAxis,
    grid: {
      // top: '24%',
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    series: series,
  };

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title,
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.toolbox = {
      show: true,
      feature: {
        magicType: { type: ["line", "bar"] },
        saveAsImage: {},
      },
    };
  }

  return option;
}
